import { apiGetActiveArchiveList, apiGetArchiveList, apiGetArchiveSideBar } from "api/archiveApi";
import DateComp from "components/Table2/CellComps/Date";
import Text from "components/Table2/CellComps/Text";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const useDocumentArchiveModel = () => {
  const dispatch = useDispatch();
  const { archiveSideBarItem, archiveLoading, archiveDataLoading, archiveItem } = useSelector(
    (state: any) => state.archiveSidebarReducer
  ) ?? {
    archiveSideBarItem: [],
    archiveItem: [],
    archiveLoading: false,
    archiveDataLoading: false,
  };

  const paginationState = useSelector((state: any) => state?.paginationReducer);
  const token = useSelector((state: any) => state?.businessReducer?.business?.token);

  // state
  const [count, setCount] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
  });

  const [activeArchive, setActiveArchive] = useState<any>(undefined);

  // ====
  // effects

  useEffect(() => {
    getArchiveSideBarData();
    //@ts-ignore
    dispatch(apiGetArchiveList({pagination: paginationState, token}))
    return () => {};
  }, []);

  useEffect(() => {
    if (activeArchive) {
      getActiveArchiveData();
    }

    return () => {};
  }, [activeArchive]);

  // ====

  // functions

  function getArchiveSideBarData() {
    //@ts-ignore
    if (token) dispatch(apiGetArchiveSideBar());
  }

  const getActiveArchiveData = () => {
    //@ts-ignore
    if (token) dispatch(apiGetActiveArchiveList({ pagination: paginationState, token, type: activeArchive?.model }));
  };

  // =====

  // constants
  const table = {
    headers: [
      { label: "نام فایل", style: { minWidth: "250px" } },
      { label: "سند مربوطه", style: { minWidth: "200px" } },
      { label: "تاریخ ثبت", style: { minWidth: "150px" } },
      { label: "سایز فایل", style: { minWidth: "150px" } },
    ],
    cols: [
      { Comp: Text, key: "fileName", options: { editable: false } },
      { Comp: Text, key: "type", options: { editable: false } },
      { Comp: DateComp, key: "date", options: { editable: false } },
      { Comp: Text, key: "size", options: { editable: false } },
    ],
  };

  // ========

  return {
    table,
    count,
    pagination,
    setPagination,
    archiveSideBarItem,
    archiveLoading,
    archiveItem,
    archiveDataLoading,
    activeArchive,
    setActiveArchive,
  };
};

export default useDocumentArchiveModel;
